export const EVENT_DAYS = [
  { label: 'Sunday', value: 'Sunday' },
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
];

export const DEFROST_SCHEDULE_TABLE_HEADERS = [
  { label: '', key: 'dirty', width: undefined }, // Dirty event cell
  { label: 'EVENT DAYS', key: 'eventDays', width: undefined },
  { label: 'START TIME', key: 'startTime', width: undefined },
  { label: 'REPEAT UNTIL', key: 'endDate', width: undefined },
  { label: '', key: 'delete', width: undefined }, // Delete event cell
];
